export const GET_REQUEST_TODOS = "GET_REQUEST_TODOS";
export const GET_SUCCESS_TODOS = "GET_SUCCESS_TODOS";
export const GET_FAILED_TODOS = "GET_FAILED_TODOS";
export const API_URL = "https://jsonplaceholder.typicode.com/todos";
